import React, { useEffect } from 'react';
import { useSettings, useStore } from '../context/store';
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import Moment from 'moment';

// import 'react-dates/lib/css/_datepicker.css';
export default function DatePicker() {
	const { state, dispatch } = useStore();

	const settings = useSettings();

	const getResultCount = function () {
		const count = settings.postsPerPage * state.currentPage;

		return count < state.postsCount ? count : state.postsCount;
	};

	function closeLocalModals() {
		const filterModals = document.querySelectorAll(
			'.tf-datepicker, .tf-taxonomy'
		);

		if (filterModals) {
			filterModals.forEach((filterModal) => {
				filterModal.classList.remove('active');
			});
		}
	}

	function closeModal() {
		const mainModal = document.querySelector('.tf-mobile-modal');
		mainModal.classList.remove('active');
		closeLocalModals();
	}

	let numberOfMonths = 1;
	if (window.matchMedia('(min-width: 620px)')) {
		numberOfMonths = 2;
	}

	window.addEventListener(
		'resize',
		function (event) {
			if (window.matchMedia('(min-width: 620px)')) {
				numberOfMonths = 2;
			}
		},
		true
	);

	return (
		<div className="tf-datepicker">
			<div className="tf-datepicker__title tf-mobile-button">
				{settings.departureDateTitle}
			</div>

			<div className="tf-mobile-button-content">
				<div className="tf-mobile-title">
					<button className="tf-close"></button>
					<span className="tf-label">Dates</span>
					<button className="tf-close-all"></button>
				</div>

				<div className="tf-mobile-main">
					<DateRangePicker
						startDate={state.selectedStartDate}
						startDateId="tf-start-date"
						endDate={state.selectedEndDate}
						endDateId="tf-end-date"
						onDatesChange={(dates) =>
							dispatch({ type: 'setDateRange', payload: dates })
						}
						focusedInput={state.focusedDateInput}
						onFocusChange={(focusedInput) =>
							dispatch({
								type: 'setFocusedDateInput',
								payload: focusedInput,
							})
						}
						showClearDates={false}
						minDate={Moment()}
						hideKeyboardShortcutsPanel={true}
						numberOfMonths={numberOfMonths}
						renderCalendarInfo={() => (
							<div className="tf-datepicker__bottom">
								<button
									className="tf-datepicker__clear c-btn c-btn--tertiary"
									onClick={() =>
										dispatch({
											type: 'setDateRange',
											payload: {
												startDate: null,
												endDate: null,
											},
										})
									}
								>
									Clear
								</button>
							</div>
						)}
					/>
				</div>

				<button
					className="tf-apply-filters"
					onClick={() => closeModal()}
				>
					Apply Filters
				</button>

				<div className="tf-mobile-info">
					<span>Showing {getResultCount()} Trips</span>

					<span onClick={() => dispatch({ type: 'resetFilters' })}>
						Clear Filters
					</span>
				</div>
			</div>
		</div>
	);
}
